import { Alert } from '@material-ui/lab';

import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const MaxDistributionsAlert = ({ description }: { description: string }) => {
  const { customBorderRadius } = useCustomTheme();

  return (
    <Alert
      severity={'warning'}
      icon={<Icon size={22}>{'error'}</Icon>}
      style={{ borderRadius: customBorderRadius.paper }}
    >
      <Text tId={description} />
    </Alert>
  );
};
